{
  "welcome_subtitle": "Meine Live-Projekte",
  "welcome_title": "Willkommen, {{ name }}",
  "view_project": "Projekt ansehen",
  "my_projects": "Meine Projekte",
  "create_project_form": {
    "title": "Neues Projekt",
    "title_edit": "Projekt bearbeiten",
    "project_name": "Name des Projekts",
    "project_expiry_date": "Ablaufdatum des Projekts",
    "project_apps": "Anwendungen und Funktionen",
    "billing_provider": "Abrechnungsanbieter",
    "subscription_plan": "Abonnementplan",
    "subscription_plan_price": "Preis",
    "billing_invalid": "Bitte wählen Sie eine Abrechnungsmethode",
    "plan_invalid": "Bitte wählen Sie einen Tarif",
    "price_invalid": "Bitte wählen Sie einen Preis",
    "name_invalid": "Bitte geben Sie einen Namen ein.",
    "date_invalid": "Bitte geben Sie ein gültiges Datum nach dem heutigen Tag ein.",
    "max_users": "Max. Anzahl Benutzer",
    "max_users_invalid": "Die maximale Anzahl der Benutzer muss mehr als 0 betragen",
    "unlimited_users": "Unbegrenzte Anzahl von Benutzern",
    "unlimited": "Unbegrenzt"
  },
  "billing_popover": {
    "renew_button": "Abonnement jetzt verlängern",
    "body": "Ihr Abonnement ist abgelaufen. Um wieder Zugriff auf Ihr Projekt zu erhalten, verlängern Sie es noch heute."
  },
  "service_unavailable": {
    "body": "Dieses Projekt ist abgelaufen. Bitte kontaktieren Sie den Projektadministrator, um das Abonnement zu verlängern.",
    "support": "Für weitere Unterstützung wenden Sie sich bitte an"
  }
}